import { create } from "zustand";
import { onOpenCaptchaPopup, onCloseCaptchaPopup } from "@/components/popup-dispatcher/PopupDispatcher";

type Resolver = (token: string) => void

interface CaptchaState {
  subject: string | null;
  solve: (subject: string) => Promise<string>;
  resolve?: Resolver;
  close: () => void;
}

export const useCaptchaStore = create<CaptchaState>((set) => ({
  subject: null,

  solve: (subject) =>
    new Promise<string>((resolve) => {
      set({ subject, resolve: resolve });

      if (subject) {
        onOpenCaptchaPopup();
      }
    }),

  close: () => {
    set({ subject: null, resolve: undefined });
    onCloseCaptchaPopup();
  },
}));
